import InitCMSSizeGuide from '../../CMS/CMS-SizeGuide/init';

export class SizeGuide {
  constructor(element) {
    this.node = element;
  }

  init() {
    InitCMSSizeGuide();
    this.node.querySelector('.Module-SizeGuide-Selector')?.addEventListener('change', this.#selectorHandle.bind(this));
  }

  #selectorHandle(e) {
    const el = e.target;
    const value = el.value;

    // Handle size guide specific logic
    var content = this.node.querySelector('[data-size-guide-json]').innerHTML;
    if (content.includes('WOVEN')) {
      document.querySelector('#bottom_section').classList.add('pdp-c-size-guide__bottom_section');
      document
        .querySelector('.pdp-c-size-guide__header_section')
        .classList.add('pdp-c-size-guide__header_section_hide');
    }

    const elements = document.getElementsByClassName('table-body-rows');
    for (const elem of elements) {
      elem.style.display = 'none';
      // This matches gracefully either "XS, S, X, L..." or "XS (22-24), S (26-28)..." value cases
      // because the value can come of two ways. First one as follow "XS" or "S"
      // second one, it can come letter with numbers, i.e. M (32-34).
      if (elem.id == value || new RegExp(`^${value}\\b`).test(elem.id)) {
        elem.style.display = 'table';
        elem.style.width = '100%';
      }
    }
  }

  close() {
    this.node
      .querySelector('.Module-SizeGuide-Selector')
      ?.removeEventListener('change', this.#selectorHandle.bind(this));
    // Remove # character in the url after closing this modal
    history.replaceState(null, null, window.location.pathname.replace(/\/\//g, '/') + window.location.search);
  }
}
